module.exports = __webpack_public_path__ + "media/images/milbank-logo-69ccc246382bd0f94a1212e56ee25b17.svg";